/* eslint-disable jsx-a11y/media-has-caption */

import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import Hls from 'hls.js';
import classes from './classes.module.scss';

function VideoPlayer({
  videoUrl,
  videoRef,
  onPlayerClick,
  onPlaying,
  muted,
  controls = true,
  className,
  loop,
  poster
}) {
  useEffect(() => {
    const video = videoRef.current;
    if (video && videoUrl) {
      if (videoUrl.includes('.m3u8')) {
        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(videoUrl);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            if (video.muted) video.play();
          });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = videoUrl;
        }
      } else {
        video.src = videoUrl;
      }
      video.muted = muted;
    }
    return () => {
      if (video && Hls.isSupported()) {
        const hls = new Hls();
        hls.destroy();
      }
    };
  }, [videoUrl]);

  useEffect(() => {
    const video = videoRef.current;
    if (video && poster) {
      video.poster = poster;
    }
  }, [poster]);

  const onPlayerClickHandler = (e) => {
    if (onPlayerClick) {
      onPlayerClick(e);
    }
  };

  const videoPlayer = useMemo(() => (
    <video
      data-testid="hero-banner-video"
      ref={ videoRef }
      controls={ controls }
      width="100%"
      height="100%"
      playsInline
      className={ classNames(classes.player, className) }
      onClick={ onPlayerClickHandler }
      onTouchStart={ onPlayerClick }
      onPlaying={ onPlaying }
      muted= { muted }
      autoPlay
      loop={ loop }
      poster={ poster }
      preload="none"
      suppressHydrationWarning
    />
  ), []);

  return videoPlayer;
}

export default VideoPlayer;
